import { Typography } from '@shinetools/sunshine-universal';

import * as Layout from 'layouts/ContentLayout';

export const NewExportRecurring = () => {
  return (
    <Layout.Root>
      <Layout.Body>
        <Typography.Text>Placeholder new recurring export page</Typography.Text>
      </Layout.Body>
    </Layout.Root>
  );
};
